import React from "react"
import { Form, Button } from "antd"
import { PlusOutlined } from "@ant-design/icons"
import SiteSurveysContactsFormPiece from "./SiteSurveysContactsFormPiece"

function SiteSurveysContactsForm(props) {
    /////*** event handler methods start ***/////
    const handleRemove = (field, remove) => {
        let allValues = props.form.getFieldValue()

        if (!!allValues.contacts_attributes[field.name]) {
            if (!!allValues.contacts_attributes[field.name]["site_survey_id"]) {
                let updatedFieldsToRemove = [...props.toRemove]
                updatedFieldsToRemove.push({ ...allValues.contacts_attributes[field.name], _destroy: true })
                props.setToRemove(updatedFieldsToRemove)
            }
        }
        remove(field.name)
    }
    /////*** event handler methods end ***/////

    return (
        <div id={"site-surveys-contacts-form"} className={"card"}>
            <Form.List name={"contacts_attributes"}>
                {(fields, { add, remove }) => (
                    <>
                        {fields.map((field) => (
                            <SiteSurveysContactsFormPiece {...field} key={field.key} remove={() => handleRemove(field, remove)} />
                        ))}
                        <Form.Item className={"add-field"}>
                            <Button block onClick={() => add()} icon={<PlusOutlined />}>
                                Add field
                            </Button>
                        </Form.Item>
                    </>
                )}
            </Form.List>
        </div>
    )
}

export default SiteSurveysContactsForm
